import * as React from "react";
import { UitkLayoutSizes } from "../uitk-react-layout/index.js";
import { classNames } from "../uitk-react-utils/index.js";
import {
  UitkLayoutFlexItemAlignSelfs,
  UitkLayoutFlexItemGrows,
  UitkLayoutFlexItemShrinks
} from "./types.js";
export const UitkLayoutFlexItem = (props) => {
  const { alignSelf, className, maxWidth, minWidth, grow, shrink, style } = props;
  const childrenArray = React.Children.toArray(props.children);
  if (!childrenArray.length) {
    return null;
  }
  const firstChild = childrenArray[0];
  const firstChildClassName = firstChild?.props?.className;
  const baseClass = "uitk-layout-flex-item";
  const wrapperStyles = {
    flexBasis: minWidth && typeof minWidth === "number" ? `${minWidth}px` : void 0,
    maxWidth: maxWidth && typeof maxWidth === "number" ? `${maxWidth}px` : void 0,
    ...style
  };
  const wrapperClassNames = classNames(
    alignSelf && `${baseClass}-${UitkLayoutFlexItemAlignSelfs.get(alignSelf)}`,
    baseClass,
    firstChildClassName,
    maxWidth && typeof maxWidth === "string" && `${baseClass}-max-width-${UitkLayoutSizes.get(maxWidth)}`,
    minWidth && typeof minWidth === "string" && `${baseClass}-flex-basis-${UitkLayoutSizes.get(minWidth)}`,
    typeof grow !== "undefined" && Number.isInteger(grow) && `${baseClass}-${UitkLayoutFlexItemGrows.get(grow)}`,
    typeof shrink !== "undefined" && Number.isInteger(shrink) && `${baseClass}-${UitkLayoutFlexItemShrinks.get(shrink)}`,
    className
  );
  if (childrenArray.length <= 1) {
    return React.cloneElement(firstChild, { className: wrapperClassNames, style: wrapperStyles });
  }
  return /* @__PURE__ */ React.createElement("div", { className: wrapperClassNames, style: wrapperStyles }, childrenArray);
};
UitkLayoutFlexItem.displayName = "UitkLayoutFlexItem";
